{
  "status": {
    "DRAFT": "مسودة",
    "FINAL": "نهائي"
  },
  "week": {
    "of": "أسبوع {{day}}"
  },
  "errors": {
    "STATUS_REPORT_EXISTS": "لهذا الأسبوع تقرير بالفعل. افتحه من تقارير المشروع لمتابعة الكتابة.",
    "STATUS_REPORT_FINAL": "هذا التقرير نهائي ولا يمكن تعديله. أعد التحميل لعرضه كما ثُبّت.",
    "STATUS_REPORT_WEEK": "اختر هذا الأسبوع أو أسبوعًا سابقًا، بدءًا من أسبوع بدء المشروع.",
    "VERSION_CONFLICT": "عدّل شخص آخر هذا التقرير في الأثناء. أعد التحميل لعرض نسخته.",
    "PROJECT_FEATURE_OFF": "لا يمكن نسخ الأرقام الرئيسية: مؤشرات المشاريع متوقفة لهذا المشروع ولا يوجد سجل للأسبوع. شغّل المؤشرات من إعدادات المشروع، أو اطلب ذلك من المسؤول."
  },
  "sections": {
    "summary": "الملخص",
    "progress": "الإنجاز هذا الأسبوع",
    "risksIssues": "المخاطر والمشكلات",
    "nextSteps": "الخطوات التالية"
  },
  "sectionHints": {
    "summary": "الأسبوع في بضع جمل، وهو أول ما يقرؤه القارئ.",
    "progress": "ما أُنجز هذا الأسبوع.",
    "risksIssues": "ما قد يؤخر العمل أو يزيد التكلفة، وما يُتخذ حياله.",
    "nextSteps": "ما سيجري في الأسبوع القادم، ومن يتولاه."
  },
  "figures": {
    "title": "الأرقام الرئيسية",
    "fromRecord": "من سجل الأسبوع ({{date}})",
    "live": "أرقام حية حتى {{date}}",
    "refresh": "تحديث الأرقام",
    "health": "السلامة",
    "progress": "الإنجاز",
    "plannedFinish": "موعد الانتهاء المخطط",
    "forecastFinish": "موعد الانتهاء المتوقع",
    "slip": "مقارنة بالخطة",
    "onTime": "وفق الخطة",
    "late_zero": "متأخر {{n}} يوم عمل",
    "late_one": "متأخر يوم عمل واحد",
    "late_two": "متأخر يومَي عمل",
    "late_few": "متأخر {{n}} أيام عمل",
    "late_many": "متأخر {{n}} يوم عمل",
    "late_other": "متأخر {{n}} يوم عمل",
    "early_zero": "متقدم {{n}} يوم عمل",
    "early_one": "متقدم يوم عمل واحد",
    "early_two": "متقدم يومَي عمل",
    "early_few": "متقدم {{n}} أيام عمل",
    "early_many": "متقدم {{n}} يوم عمل",
    "early_other": "متقدم {{n}} يوم عمل",
    "bac": "الموازنة",
    "ac": "المصروف حتى الآن",
    "eac": "التكلفة النهائية المتوقعة",
    "forecastMargin": "هامش الربح المتوقع",
    "billed": "المفوتر",
    "collected": "المحصّل",
    "outstanding": "المستحق غير المحصّل",
    "moneyHidden": "تظهر الأرقام المالية لمن يحق لهم الاطلاع على أموال المشاريع."
  },
  "signals": {
    "title": "تنبيهات ذلك الأسبوع",
    "none": "لا تحذيرات في ذلك الأسبوع."
  },
  "latest": {
    "title": "تقرير الحالة الأسبوعي",
    "all": "كل التقارير",
    "failed": "تعذّر تحميل تقارير الحالة.",
    "retry": "إعادة المحاولة",
    "noSummary": "لا ملخص بعد.",
    "finalised": "ثبّته {{name}}، {{date}}",
    "updated": "آخر حفظ {{date}}",
    "open": "فتح",
    "openLabel": "فتح تقرير أسبوع {{day}}",
    "none": "لا توجد تقارير حالة بعد.",
    "finish": "إكمال تقرير الأسبوع الماضي",
    "write": "كتابة تقرير هذا الأسبوع"
  },
  "create": {
    "title": "كتابة تقرير الحالة الأسبوعي",
    "description": "تقرير واحد لكل أسبوع، من الأحد إلى السبت. تُنسخ أرقامه الرئيسية من المشروع.",
    "week": "الأسبوع",
    "weekHint": "هذا الأسبوع أو أسبوع سابق، بدءًا من أسبوع بدء المشروع.",
    "thisWeek": "{{week}} (هذا الأسبوع)",
    "hasReport": "{{week}}: له تقرير",
    "takenTitle": "لهذا الأسبوع تقرير بالفعل",
    "openIt": "فتح تقرير أسبوع {{day}}",
    "notStarted": "لم يبدأ المشروع بعد: يمكن كتابة التقرير ابتداءً من أسبوعه الأول.",
    "cancel": "إلغاء",
    "confirm": "بدء التقرير",
    "failed": "لم يبدأ التقرير",
    "done": "بدأ تقرير أسبوع {{day}}"
  },
  "list": {
    "title": "تقارير الحالة",
    "back": "العودة إلى {{code}}",
    "write": "كتابة تقرير",
    "tableLabel": "تقارير حالة {{code}}",
    "empty": "لا توجد تقارير حالة بعد.",
    "emptyWrite": "اكتب التقرير الأول: بضعة أسطر عن الأسبوع، والأرقام تُنسخ لك.",
    "emptyRead": "يكتبها مدير المشروع كل أسبوع.",
    "finalisedOn": "ثُبّت {{date}}",
    "updatedOn": "حُفظ {{date}}",
    "search": "البحث في نصوص التقارير",
    "clearSearch": "مسح البحث",
    "noMatch": "لا يوجد تقرير يذكر ذلك.",
    "startsLater": "تبدأ التقارير في أسبوع {{date}}، أول أسابيع المشروع."
  },
  "columns": {
    "week": "الأسبوع",
    "status": "الحالة",
    "summary": "الملخص",
    "by": "بواسطة",
    "project": "المشروع",
    "health": "السلامة",
    "author": "كتبه",
    "manager": "المدير",
    "lastReport": "آخر تقرير"
  },
  "editor": {
    "documentTitle": "تقرير الحالة",
    "toList": "العودة إلى التقارير",
    "back": "تقارير حالة {{code}}",
    "ariaTitle": "تقرير الحالة، أسبوع {{day}}، {{code}}",
    "author": "كتبه {{name}}",
    "savedAt": "آخر حفظ {{date}}",
    "save": "حفظ",
    "noChanges": "لا شيء للحفظ بعد",
    "saved": "حُفظ التقرير",
    "finalise": "تثبيت التقرير",
    "print": "طباعة",
    "delete": "حذف المسودة",
    "refreshed": "حُدّثت الأرقام",
    "finalisedToast": "تم تثبيت تقرير أسبوع {{day}}",
    "deleted": "حُذفت مسودة أسبوع {{day}}",
    "finalTitle": "تقرير نهائي",
    "finalBody": "ثبّته {{name}} في {{date}}. لا يمكن تعديل التقرير النهائي.",
    "readOnlyTitle": "للقراءة فقط",
    "readOnlyBody": "يكتب هذا التقرير مدير المشروع أو من يدير المشاريع.",
    "aiAssisted": "صيغت هذه المسودة بمساعدة المساعد الذكي. تحقق من الأرقام قبل الحفظ.",
    "failed": "لم تنجح العملية",
    "staleTitle": "تغيّر هذا التقرير في الأثناء",
    "staleBody": "حفظه شخص آخر أو حدّث أرقامه أو ثبّته منذ فتحته. أعد التحميل لعرضه كما هو الآن، وانسخ أولًا أي نص تريد الاحتفاظ به.",
    "reload": "إعادة التحميل",
    "counter": "{{n}} / {{max}}",
    "nearLimit": "بقي أقل من {{n}} حرف.",
    "atLimit": "بلغت الحد الأقصى لعدد الأحرف."
  },
  "finalise": {
    "title": "تثبيت تقرير أسبوع {{day}}؟",
    "body": "لا يمكن تعديل التقرير النهائي: يبقى نصه وأرقامه كما هي الآن. يُحفظ النص غير المحفوظ أولًا.",
    "confirm": "تثبيت التقرير"
  },
  "delete": {
    "title": "حذف مسودة أسبوع {{day}}؟",
    "body": "تُحذف المسودة ونصها، ويمكن بعد ذلك بدء تقرير جديد لهذا الأسبوع.",
    "confirm": "حذف المسودة"
  },
  "print": {
    "title": "تقرير الحالة الأسبوعي",
    "back": "العودة إلى التقرير",
    "week": "الأسبوع",
    "weekRange": "من {{from}} إلى {{to}}",
    "finalised": "تم التثبيت",
    "project": "المشروع",
    "customer": "العميل",
    "manager": "مدير المشروع",
    "draft": "مسودة: هذا التقرير ليس نهائيًا بعد، وقد يتغير نصه وأرقامه.",
    "footerFinal": "ثبّته {{name}} في {{date}}.",
    "footerDraft": "مسودة، آخر حفظ {{date}}."
  },
  "reading": {
    "title": "تقارير الحالة الأسبوعية",
    "range": "من {{from}} إلى {{to}}",
    "week": "الأسبوع",
    "thisWeek": "{{week}} (هذا الأسبوع)",
    "previousWeek": "الأسبوع السابق",
    "nextWeek": "الأسبوع التالي",
    "status": "الحالة",
    "anyStatus": "أي حالة",
    "manager": "المدير",
    "views": "التقارير أو المشاريع بلا تقرير",
    "reports": "التقارير",
    "missing": "بلا تقرير",
    "reportsLabel": "تقارير حالة أسبوع {{day}}",
    "missingLabel": "مشاريع نشطة بلا تقرير لأسبوع {{day}}",
    "noReports": "لا تقارير لهذا الأسبوع بعد.",
    "noneMissing": "لكل مشروع نشط تقرير لهذا الأسبوع.",
    "noMatch": "لا شيء يطابق عوامل التصفية هذه.",
    "never": "لا يوجد بعد",
    "search": "البحث عن مشروع بالرمز أو الاسم",
    "clearSearch": "مسح البحث"
  }
}
